export default {
	accepted: 'Accepted',
	pending: 'Pending',
	rejected: 'Rejected',
	'add-purchase': 'add offer',
	'edit-purchase': 'edit offer',
	'preview-purchase': 'preview offer',
	'alert-message': 'This operation will also delete both the related receiving entry and the material journal.',
	waiting: 'Waiting',
	'purchase-status': 'Offer status',

	'administration-acceptance': 'Administration acceptance',
	'farmer-acceptance': 'Farmer acceptance',
	'administration-price': 'Administration price',
}